var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9457 16.2095L43.8662 5.85298V26.4479L31.9457 16.2095ZM16.5852 17.9634L20.7713 21.5971C21.4282 22.1553 22.2848 22.4925 23.2209 22.4925H23.2538H23.279C24.217 22.4925 25.0736 22.1533 25.7383 21.5913L25.7325 21.5952L29.9185 17.9615L42.6433 28.8897H3.86627L16.5852 17.9634ZM3.84883 3.39756H42.6666L24.0213 19.5913C23.8116 19.7571 23.5521 19.8473 23.2848 19.8471H23.2577H23.2325C22.9643 19.8475 22.7039 19.7566 22.4941 19.5894L22.4961 19.5913L3.84883 3.39756ZM2.64534 5.85104L14.5639 16.2076L2.64534 26.4401V5.85104ZM44.5057 1.12043C44.0406 0.887873 43.4941 0.752214 42.9146 0.752214H3.6027C3.041 0.752349 2.48702 0.883049 1.98449 1.134L2.00581 1.12431C1.40421 1.42103 0.897571 1.88008 0.543127 2.44958C0.188683 3.01909 0.000556875 3.67637 0 4.34717L0 27.9363C0.00102597 28.8909 0.380721 29.8062 1.05577 30.4812C1.73083 31.1563 2.6461 31.536 3.60077 31.537H42.9088C43.8635 31.536 44.7787 31.1563 45.4538 30.4812C46.1288 29.8062 46.5085 28.8909 46.5096 27.9363V4.34717C46.5096 2.93826 45.6976 1.71733 44.5154 1.13012L44.4941 1.12043H44.5057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.35f346b82c7afdf6cecac946d9d95a58.svg";
export { ForwardRef as ReactComponent };